/**
 * The editorial pages' paper, which the header above them paints too. White,
 * stated once so every surface that has to be opaque — the nav's band, the
 * blocks that travel over the pinned nav — paints the same ground.
 */
export const EDITORIAL_GROUND = 'bg-white';

/** What the directory says about itself when the CMS has given it nothing. */
export const EDITORIAL_STATEMENT_FALLBACK =
    'Ideas, projects and expert insight from the architecture and design community, written by the people who build it.';
